/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFileArrowDown: {
  name: 'file-arrow-down';
  data: string;
} = {
  name: 'file-arrow-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 2A1.5 1.5 0 0 1 4 .5h4.586a1.5 1.5 0 0 1 1.06.44l3.415 3.414a1.5 1.5 0 0 1 .439 1.06V14a1.5 1.5 0 0 1-1.5 1.5H4A1.5 1.5 0 0 1 2.5 14V2ZM4 1.5a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V5.5H10A1.5 1.5 0 0 1 8.5 4V1.5H4Zm5.5.707V4a.5.5 0 0 0 .5.5h1.793L9.5 2.207ZM8 6.5a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 10.793V7a.5.5 0 0 1 .5-.5Z" fill="currentColor"/></svg>`,
};
